import { useLayoutEffect } from 'react';
export function sizeEditorDescription(node) {
  if (!node) return;
  const style = getComputedStyle(node);
  const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
  const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
  const maximum = 6 * parseFloat(style.lineHeight) + padding + border;
  const minimum = parseFloat(style.minHeight) || 96;
  node.style.height = '0px';
  const fullHeight = node.scrollHeight + border;
  node.style.height = `${Math.max(minimum, Math.min(maximum, fullHeight))}px`;
  node.style.overflowY = fullHeight > maximum ? 'auto' : 'hidden';
}
// Browser visualViewport is the keyboard boundary. Native gesture/IME behavior is separate.
export default function useEditorFieldLayout(inputs, description, ready, textScale = 1) {
  useLayoutEffect(() => {
    if (!ready) return;
    const textarea = inputs.current.description;
    const resize = () => sizeEditorDescription(textarea);
    resize();
    // Observe width only: changing textarea height must not create a resize loop.
    if (textarea?.parentElement) {
      let width = textarea.parentElement.getBoundingClientRect().width;
      const widthObserver =
        typeof ResizeObserver === 'undefined'
          ? null
          : new ResizeObserver((entries) => {
              const next = entries[0].contentRect.width;
              if (next !== width) {
                width = next;
                resize();
              }
            });
      widthObserver?.observe(textarea.parentElement);
      const reveal = () => {
        const field = document.activeElement;
        if (!Object.values(inputs.current).includes(field) || !field?.getBoundingClientRect) return;
        const viewport = window.visualViewport,
          box = field.getBoundingClientRect();
        const toolbarBottom =
          document
            .querySelector('.pp-playlist-editor .pp-playlist-toolbar')
            ?.getBoundingClientRect().bottom || 0;
        const top = Math.max(viewport?.offsetTop || 0, toolbarBottom) + 12;
        const bottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - 16;
        if (box.bottom > bottom)
          window.scrollBy({ top: Math.min(box.bottom - bottom, box.top - top), behavior: 'auto' });
        else if (box.top < top) window.scrollBy({ top: box.top - top, behavior: 'auto' });
      };
      window.addEventListener('resize', resize);
      window.visualViewport?.addEventListener('resize', reveal);
      return () => {
        widthObserver?.disconnect();
        window.removeEventListener('resize', resize);
        window.visualViewport?.removeEventListener('resize', reveal);
      };
    }
  }, [inputs, description, ready, textScale]);
}
